export const HIDE_SUBHEADER_LIST = [
  '/survey-central/survey/',
];
